module.exports = __webpack_public_path__ + "static/media/11.ff4990f2.jpg";